var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.49992C13.7985 8.49992 13.5 8.7984 13.5 9.16659C13.5 9.53478 13.7985 9.83325 14.1667 9.83325H15C15.3682 9.83325 15.6667 9.53478 15.6667 9.16659C15.6667 8.7984 15.3682 8.49992 15 8.49992H14.1667Z",
    fill: "#1B3DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8217 1.83325C5.99351 1.83325 5.3217 2.50506 5.3217 3.33325V5.99992H3.33334C2.50515 5.99992 1.83334 6.67173 1.83334 7.49992V13.3333C1.83334 14.1614 2.50515 14.8333 3.33334 14.8333H5.16667V16.6666C5.16667 17.4948 5.83848 18.1666 6.66667 18.1666H13.3333C14.1615 18.1666 14.8333 17.4948 14.8333 16.6666V14.8333H16.6667C17.4949 14.8333 18.1667 14.1614 18.1667 13.3333V7.49992C18.1667 6.67173 17.4949 5.99992 16.6667 5.99992H14.6784V3.33325C14.6784 2.50506 14.0066 1.83325 13.1784 1.83325H6.8217ZM14.8333 13.4999H16.6667C16.7585 13.4999 16.8333 13.4251 16.8333 13.3333V7.49992C16.8333 7.40811 16.7585 7.33325 16.6667 7.33325H3.33334C3.24153 7.33325 3.16667 7.40811 3.16667 7.49992V13.3333C3.16667 13.4251 3.24153 13.4999 3.33334 13.4999H5.16667V11.6666C5.16667 11.2984 5.46515 10.9999 5.83334 10.9999H14.1667C14.5349 10.9999 14.8333 11.2984 14.8333 11.6666V13.4999ZM6.5 16.6666C6.5 16.7584 6.57486 16.8333 6.66667 16.8333H13.3333C13.4251 16.8333 13.5 16.7584 13.5 16.6666V12.3333H6.5V16.6666ZM13.345 5.99992H6.65503V3.33325C6.65503 3.24144 6.72989 3.16659 6.8217 3.16659H13.1784C13.2702 3.16659 13.345 3.24144 13.345 3.33325V5.99992Z",
    fill: "#1B3DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPrint);
export default __webpack_public_path__ + "static/media/icons-print.38beee16bcf45e41735606d6cb38efdc.svg";
export { ForwardRef as ReactComponent };